import React, { useState } from "react"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid2"
import PeopleForm from "./PeopleForm"
import PeopleTable from "./PeopleTable"

/**
 * People page — intentionally minimal.
 *
 * Responsibilities:
 *   - Receive the initialised Supabase client as a prop.
 *   - Own the single piece of shared UI state: which person is selected.
 *   - Wire PeopleForm and PeopleTable together via that state.
 *
 * All data-fetching, mutation, realtime subscription, loading states, and
 * error handling live inside PeopleForm and PeopleTable respectively.
 */
export default function People({ supabase }) {
    const [selectedPersonId, setSelectedPersonId] = useState(null)

    return (
        <Box sx={{ width: "100%" }}>
            <Grid container spacing={4}>
                <Grid size={{ xs: 12, lg: 4 }}>
                    <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                        {selectedPersonId ? "Modifier une personne" : "Ajouter une personne"}
                    </Typography>
                    <PeopleForm
                        supabase={supabase}
                        selectedPersonId={selectedPersonId}
                        onSuccess={() => setSelectedPersonId(null)}
                    />
                </Grid>
                <Grid size={{ xs: 12, lg: 8 }}>
                    <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                        Annuaire des personnes
                    </Typography>
                    <PeopleTable
                        supabase={supabase}
                        selectedPersonId={selectedPersonId}
                        setSelectedPersonId={setSelectedPersonId}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}